import { render, staticRenderFns } from "./CloseVacancy.vue?vue&type=template&id=055e42f4&scoped=true"
import script from "./CloseVacancy.vue?vue&type=script&lang=js"
export * from "./CloseVacancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055e42f4",
  null
  
)

export default component.exports